// extracted by mini-css-extract-plugin
export default {"component":"ConsultingDayList_component__VVXj2"};